<template>
  <el-autocomplete v-model="param.customerName" :fetch-suggestions="fun_search"
                   :size="size?size:'mini'" :disabled="disabled?disabled:false"
    @change="fun_change" @select="fun_select" placeholder="请选择客户" 
  ></el-autocomplete>
</template>

<script>
  import {queryBaseCustomer} from '@/api/base.js'
  export default {
    name: 'CompChooseCustomer',
    props:['status','size','param','on_sel','disabled'],
    data() {
      return {
        customers:{rows:[]},
      }
    },
    methods: {
      fun_change(_v){
        console.log('fun_change()',_v)
        Object.assign(this.param,{customerId:0,customerName:_v})
      },
      fun_select(_v){
        console.log('fun_select()',_v)
        Object.assign(this.param,{customerId:_v.id},_v)
        if(this.on_sel) this.on_sel();
      },
      fun_search(q, cb){
        queryBaseCustomer({searchKey:this.sk,pageSize:999999,status:this.status}).then(res=>{
          for(var i of res.rows){
            i.value=i.name;
          }
          this.customers.rows = res.rows;
          var results = q ? res.rows.filter(n=>n.value.toLowerCase().indexOf(q.toLowerCase())!=-1) : res.rows;
          results.sort((i1,i2)=>i1.value.localeCompare(i2.value, 'zh-CN'));
          cb(results);
        })
      },
      fun_on_load(){},
    },
    mounted() {
      this.fun_on_load();
    },
  }
</script>

<style>
</style>